module.exports = __webpack_public_path__ + "static/media/smoke1Layer.5268f78d.png";